"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const react_router_dom_1 = require("react-router-dom");
const List_1 = __importDefault(require("@mui/material/List"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const MenuList_1 = __importDefault(require("@mui/material/MenuList"));
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const FileCopyOutlined_1 = __importDefault(require("@mui/icons-material/FileCopyOutlined"));
const profile_1 = require("companion-app-components/flux/profile");
const datasets_1 = require("companion-app-components/flux/datasets");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const auth_1 = require("companion-app-components/flux/auth");
const core_1 = require("companion-app-components/utils/core");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const Dump_1 = __importDefault(require("components/Dump"));
const QButton_1 = __importDefault(require("components/QButton"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const types_1 = require("components/Dialogs/NotificationDialog/types");
const MiniDatasetPicker_1 = __importDefault(require("components/MiniDatasetPicker"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const EmptyDialog_1 = require("components/Dialogs/EmptyDialog");
const ReportErrorDialog_1 = require("components/Dialogs/ReportErrorDialog");
const config_1 = require("containers/OverviewPage/config");
const actions_1 = require("components/Dialogs/WFDesktopFeatures/actions");
const utils_1 = require("containers/ProfilePage/utils");
const SubscriptionAlert_1 = __importDefault(require("containers/ProfilePage/SubscriptionAlert"));
const ssoActions_1 = require("data/sso/ssoActions");
const notificationsUtils_1 = require("data/notifications/notificationsUtils");
const subscriptionsSelectors = __importStar(require("data/subscriptions/subscriptionsSelectors"));
const confused_star_svg_1 = __importDefault(require("assets/confused-star.svg"));
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
const ProfileAvatar_1 = __importDefault(require("./ProfileAvatar"));
const utils_2 = require("./utils");
const ProfileMenu = ({ classes }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const theme = (0, styles_1.useTheme)();
    const { setDatasetPreference } = (0, useQPreferences_1.default)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const datasetId = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getDatasetId(state));
    const authSession = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getAuthSession(state));
    const datasets = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getActiveDatasets(state));
    const subscription = (0, react_redux_1.useSelector)((state) => subscriptionsSelectors.getActiveSubscription(state));
    const feedbackEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('feedback'));
    const financesEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('finances'));
    const profileHelpSupport = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('profileHelpSupport'));
    const resetDashEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('resetDefaultDashboard'));
    const entitledDatasets = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getEntitledDatasets(state));
    const dispatchRemoveDialog = (dialogId) => dispatch(root_ui_1.rootUiActions.removeDialog(dialogId));
    const createDialog = (uiRootData) => dispatch(root_ui_1.rootUiActions.createDialog(uiRootData));
    const doWFDesktopFeatures = () => dispatch((0, actions_1.doAdditionalDesktopFeatures)());
    const dispatchGetSSOTokenAction = (data, meta) => dispatch((0, ssoActions_1.getSSOToken)(data, meta));
    const authLogout = (payload, meta) => dispatch(auth_1.authActions.authLogout(payload, meta));
    const authSelectDataset = (dataset) => dispatch(auth_1.authActions.authSelectDataset(dataset));
    const [showHiddenMenu, setShowHiddenMenu] = React.useState(false);
    const [profileButtonAnchorEl, setProfileButtonAnchorEl] = React.useState(null);
    const popoverActions = React.useRef(null);
    React.useEffect(() => {
        if (profileButtonAnchorEl && popoverActions.current) {
            popoverActions.current.updatePosition();
        }
    }, [datasets, profileButtonAnchorEl]);
    const closeProfile = () => {
        setProfileButtonAnchorEl(null);
        setShowHiddenMenu(null);
    };
    const myAccountClick = () => {
        core_1.tracker.track(core_1.tracker.events.myAccount, { location: 'nav menu' });
        closeProfile();
        window.open(`${(0, core_1.getEnvironmentConfig)().myaccount_url}?bearer=${authSession.accessToken}`);
    };
    const logoutClick = () => authLogout({ reason: 'AUTH_LOGOUT_USER_INITIATED' }, { context: 'profile' });
    const openDesktopAdditionalFeatures = () => {
        closeProfile();
        doWFDesktopFeatures();
    };
    const helpClick = () => {
        closeProfile();
        window.open('https://www.quicken.com/support');
    };
    const handleDatasetClick = (dataset) => {
        if (datasetId !== dataset.id) {
            core_1.tracker.track(core_1.tracker.events.datasetChange, { location: 'nav menu' });
            setTimeout(() => authSelectDataset(auth_1.authTypes.AuthSelectDatasetPayload({ dataset })), 100);
            closeProfile();
            createDialog(root_ui_1.rootUiTypes.mkRootUiData({
                type: types_1.DIALOG_TYPE,
                allowNesting: false,
                props: (0, immutable_1.Map)((0, types_1.mkNotificationDialogProps)({
                    buttonLabel: null,
                    content: (<div className={classes.datasetSwitchingContent}>
              <Typography_1.default variant="body1">
                Switching to {dataset.name}
              </Typography_1.default>
              <CircularProgress_1.default classes={{ root: classes.datasetSwitchingProgress }} size={50}/>
            </div>),
                    dialogProps: {
                        disableBackdropClick: true,
                        disableEscapeKeyDown: true,
                    },
                    title: '',
                })),
            }));
        }
        else {
            setTimeout(closeProfile, 100); // the delay is only for feel to the user
        }
    };
    const profileClick = (e) => {
        if (location.pathname === '/profile') {
            return;
        }
        setProfileButtonAnchorEl(e.currentTarget);
    };
    const handleProfileClose = () => {
        closeProfile();
    };
    const getFirstLetterOfUserName = (userProfile) => {
        if (!userProfile) {
            return '';
        }
        const firstName = userProfile.firstName || (userProfile.primaryAddress ? userProfile.primaryAddress.fullName : '') || userProfile.username;
        return firstName[0].toUpperCase();
    };
    const goToCommunity = () => {
        dispatchRemoveDialog('community-verify-email');
        closeProfile();
        // eslint-disable-next-line no-promise-executor-return
        new Promise((resolve, reject) => dispatchGetSSOTokenAction(undefined, {
            resolve,
            reject,
            axiosConfig: {
                params: {
                    clientId: (0, core_1.getBuildConfig)().sso_client_id,
                    redirect_uri: (0, core_1.getBuildConfig)().community_url,
                },
            },
        }))
            .then((response) => {
            var _a, _b, _c;
            if (((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0].code) === 'QCS-0401-7') {
                createDialog(root_ui_1.rootUiTypes.mkRootUiData({
                    id: 'community-verify-email',
                    type: EmptyDialog_1.DIALOG_TYPE_EMPTY_DIALOG,
                    allowNesting: true,
                    props: (0, immutable_1.Map)({
                        colorBar: theme.palette.background.default,
                        content: <ZeroStateView_1.default icon={confused_star_svg_1.default} primary="Verify your email address" secondary="We sent you an email to confirm your identity. Once verified, click here to try again.">
    <QButton_1.default variant="contained" onClick={goToCommunity}>
      Go to community
    </QButton_1.default>
  </ZeroStateView_1.default>,
                    }),
                }));
            }
            else if (assert((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.redirectUri, 'no sso redirectUri')) {
                setTimeout(() => window.open(response.data.redirectUri, '_blank'), 1000); // setTimeout protects from popup blocker
            }
        })
            .catch((error) => assert(false, error));
    };
    const dataset = datasets.get(datasetId);
    const fullName = (0, utils_2.getFullName)(profile);
    const overviewLayoutAcme = (0, immutable_1.List)(config_1.overviewLayout);
    const handleShareFiles = () => {
        handleProfileClose();
        navigate('/profile', { replace: true });
    };
    const ownDatasets = datasets.filter((item) => !item.shared);
    const sharedDatasets = datasets.filter((item) => item.shared);
    const renderDatasetName = (theDataset, index, ownDataset = false) => {
        const hasValidEntitlement = entitledDatasets.get(theDataset.id);
        const noDatasetOrEntitlement = !ownDataset && !hasValidEntitlement;
        const isDisabled = noDatasetOrEntitlement || (ownDataset && !(subscription === null || subscription === void 0 ? void 0 : subscription.active));
        return (<ListItem_1.default button key={theDataset.id} onClick={() => handleDatasetClick(theDataset)} classes={{ root: classes.datasetListItemDefault }} disabled={isDisabled} sx={{
                '&.Mui-disabled': {
                    opacity: 1,
                },
            }}>
        <Dump_1.default obj={theDataset}/>
        <ListItemIcon_1.default style={{
                visibility: `${(dataset === theDataset) || noDatasetOrEntitlement
                    ? 'visible'
                    : 'hidden'}`,
                marginRight: 0,
            }}>
          {noDatasetOrEntitlement ? <img src={warning_svg_1.default} alt="alert" height={24} width={24}/> : <Check_1.default />}
        </ListItemIcon_1.default>
        <ListItemText_1.default sx={{
                opacity: isDisabled ? 0.5 : 1,
            }} primary={<div className={(0, classnames_1.default)(classes.textEllipsis, classes.datasetNameWrapper)}>
              {theDataset.name}
            </div>} secondary={ownDataset
                ? null
                : (<Typography_1.default variant="caption" color="koalaGrey">
                  {`Owner: ${(0, utils_1.getOwnerName)(theDataset.grantorFirstName, theDataset.grantorLastName)}  ${!hasValidEntitlement ? '(Subscription expired)' : ''}`}
                </Typography_1.default>)} id={`data-set-${index + 1}`}/>
        {ownDataset && <ProfileAvatar_1.default datasetId={theDataset.id}/>}
      </ListItem_1.default>);
    };
    return (<>
      <div id={'profile-menu-bar'} role={'button'} tabIndex={0} onKeyPress={() => null} onClick={profileClick} className={(0, classnames_1.default)(classes.navMenuItem)}>
        <Avatar_1.default className={classes.circleButton}>
          <div id={'profile-letter'} className={classes.firstNameLetter}>
            {getFirstLetterOfUserName(profile)}
          </div>
        </Avatar_1.default>
        <Typography_1.default style={{ marginLeft: 24, textAlign: 'left' }} className={classes.navText}>
          Profile
        </Typography_1.default>
      </div>
      <Popover_1.default action={(actions) => {
            popoverActions.current = actions;
        }} id="profile-menu" open={!!(profileButtonAnchorEl)} anchorEl={profileButtonAnchorEl} onClose={handleProfileClose} anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
        }} transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
        }} PaperProps={{
            style: {
                transform: 'translate3d(0, 0, 0)', // fixes a scroll issue: https://github.com/mui-org/@mui/material/issues/10601
            },
        }} onKeyDown={(e) => {
            if (e.altKey) { // can't use 'control' key because of MAC's control + click
                setShowHiddenMenu(true);
            }
            if (e.key === 'Escape') {
                handleProfileClose();
            }
        }} onKeyUp={() => {
            setShowHiddenMenu(false);
        }} disableEnforceFocus>
        <div className={classes.profilePopover}>
          {profile &&
            <div className={classes.profileHeader}>
            <Dump_1.default obj={{ dataset, profile, subscription }}/>
            <h3>{fullName}</h3>
            <p id="my-account-quicken-id">{profile.username}</p>
            {subscription && subscription.tierName &&
                    <p id="my-account-product-tier">{subscription.tierName}</p>}

            {showHiddenMenu && dataset &&
                    <p id="my-account-dataset-id" style={{ position: 'absolute', right: 2, top: 2 }}>
              {/* @ts-expect-error: Property 'userId' does not exist on type 'Record<Profile>  */}
              {profile.userId}:{dataset.id} 
              <IconButton_1.default size="small" onClick={() => {
                            navigator.clipboard.writeText(`user id: ${profile === null || profile === void 0 ? void 0 : profile.userId}\n`
                                + `dataset id: ${dataset === null || dataset === void 0 ? void 0 : dataset.id}\n`
                                + `email: ${profile === null || profile === void 0 ? void 0 : profile.username}`);
                            (0, notificationsUtils_1.dispatchSimpleNotification)('User copied to clipboard');
                        }}>
                <FileCopyOutlined_1.default fontSize="inherit"/>
              </IconButton_1.default>
            </p>}

            <Button_1.default variant="contained" onClick={myAccountClick} color="primary" id="my-account-button">
              My Account
            </Button_1.default>
          </div>}
          {(datasets && datasets.size > 0) && (datasets || financesEnabled) &&
            <div className={classes.profileDataset}>
            {ownDatasets &&
                    (ownDatasets.size > 1 || (ownDatasets.size > 0 && sharedDatasets.size > 0)) &&
                    <Typography_1.default color="inherit" variant="subtitle1" className={classes.profileFinancesTitle}>
                    {`My Cloud Accounts (${ownDatasets.size})`}
                  </Typography_1.default>}
            {subscription !== null && !(subscription === null || subscription === void 0 ? void 0 : subscription.active) && <SubscriptionAlert_1.default alertClass={classes.alert} label="Subscription expired. Shared Cloud Accounts are still available. "/>}
            <List_1.default disablePadding>
              {ownDatasets &&
                    (ownDatasets.size > 1 || (ownDatasets.size > 0 && sharedDatasets.size > 0)) &&
                    ownDatasets.valueSeq().map((theDataset, index) => {
                        if (index < 3) {
                            return renderDatasetName(theDataset, index, true);
                        }
                        return null;
                    })}
              {sharedDatasets.size > 0 &&
                    <Typography_1.default color="inherit" variant="subtitle1" className={classes.profileFinancesTitle}>
                  {`Shared with me (${sharedDatasets.size})`}
                </Typography_1.default>}
              {sharedDatasets && sharedDatasets.valueSeq().map((theDataset, index) => {
                    if (index < 1) {
                        return renderDatasetName(theDataset, index, false);
                    }
                    return null;
                })}
              {((ownDatasets && ownDatasets.size > 3) || (sharedDatasets && sharedDatasets.size > 1)) &&
                    <MiniDatasetPicker_1.default ownDatasets={ownDatasets} sharedDatasets={sharedDatasets} entitledDatasets={entitledDatasets} subscription={subscription} dataset={dataset} onChange={(d) => handleDatasetClick(d)} label="See all..." labelStyle={{ label: classes.financesButtonStyle }} id="mini-dataset-picker"/>}
              <div>
                <Button_1.default onClick={handleShareFiles} sx={{ textTransform: 'none', fontSize: 16 }}>
                  Manage Sharing
                </Button_1.default>
              </div>
            </List_1.default>
          </div>}
          <MenuList_1.default>
            {dataset && dataset.createdByClientId === 'quicken_webapp' &&
            <MenuItem_1.default id="my-account-do-more-quicken" onClick={openDesktopAdditionalFeatures}>
              Do more with Quicken Desktop
            </MenuItem_1.default>}
            {profileHelpSupport &&
            <MenuItem_1.default onClick={helpClick} id="my-account-help-and-support">
              Help &amp; Support
            </MenuItem_1.default>}

            <MenuItem_1.default id="feedback-launcher" onClick={goToCommunity}>
              Community
            </MenuItem_1.default>

            {resetDashEnabled &&
            <MenuItem_1.default onClick={() => {
                    closeProfile();
                    setDatasetPreference({ overviewLayoutVersion: config_1.overviewLayoutVersion, overviewPageLayout: overviewLayoutAcme });
                }} id="reset-default-dashboard">
              Reset Dashboard Layout
            </MenuItem_1.default>}

            {feedbackEnabled && showHiddenMenu &&
            <MenuItem_1.default onClick={() => {
                    closeProfile();
                    createDialog(root_ui_1.rootUiTypes.mkRootUiData({
                        id: 'report-error',
                        type: ReportErrorDialog_1.DIALOG_TYPE_REPORT_ERROR,
                        allowNesting: true,
                        props: (0, immutable_1.Map)({
                            feedbackSubject: 'send feedback',
                        }),
                    }));
                }} id="send-feedback">
              Send Feedback
            </MenuItem_1.default>}

            <MenuItem_1.default onClick={logoutClick} id="my-account-sign-out">Sign Out</MenuItem_1.default>
          </MenuList_1.default>
        </div>
      </Popover_1.default>
    </>);
};
exports.default = ProfileMenu;
